import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.css'],
  imports: [HeaderComponent, FooterComponent, RouterModule]
})
export class SitemapComponent implements OnInit {
  userDetail: any;
  constructor() { }

  ngOnInit() {
  }
  setUserDetails(data){
    this.userDetail = data.userDetail;
  }
}
